import type { IFirstStepDataFromView } from '@alfa-bank/site-dc-form-api/src/store/features/models';

import type { IPrepareCashbackData } from './models';
/**
 * Форматирует в нужный бекенду формат
 * пример 15.10.1995 -> 1995-10-15
 */
export const formatBirthdayValue = (birthday: string) => {
    const [day, month, year] = birthday.split('.');

    return `${year}-${month}-${day}`;
};

// Функция принимает возможные кэшбэки и возвращает данные для запроса
export const prepareCashbackData = ({
    basket,
    cashbackCategories,
    cashbackPackage,
    packageCashbackArray,
    selectedCashbackType,
}: IPrepareCashbackData) => {
    if (basket?.subscription) {
        if (basket.selectedCategories && basket.groupId && basket.offerId) {
            return {
                subscription: basket.subscription,
                groupId: basket.groupId,
                categories: [
                    {
                        offerId: basket.offerId,
                        ids: basket.selectedCategories,
                    },
                ],
            };
        }

        return { subscription: basket.subscription };
    }

    if (selectedCashbackType === 'categories' && cashbackCategories) {
        return cashbackCategories;
    }

    if (selectedCashbackType === 'package' && cashbackPackage) {
        return { subscription: cashbackPackage };
    }

    if (packageCashbackArray?.length) {
        return { subscription: packageCashbackArray[0] };
    }

    return undefined;
};

interface IGetAdditionalProducts {
    /** продукты из старого вида гибкой ак */
    additionalProducts?: string[];
    /** продукты из корзины */
    basketProducts?: string[];
    /** набор дефолтных продуктов */
    defaultProducts?: string[];
    /** Флаг: карусель гибкой ак показана */
    showCarousel?: boolean;
}

export const getAdditionalProducts = ({
    additionalProducts,
    basketProducts,
    defaultProducts,
    showCarousel,
}: IGetAdditionalProducts): IFirstStepDataFromView['additionalProducts'] => {
    if (basketProducts?.length) return basketProducts;

    if (additionalProducts) return additionalProducts;

    if (!showCarousel && defaultProducts) return defaultProducts;
};
